import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
import { GameFontStyle } from "../style/GameFontStyle";
export class GameFreeSpinsCounterProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.animation = new SpineProperties("FreeSpinsCounter", "Game", new Point(1660, 500));
        this.freeSpinsValue = new TextFieldProperties(GameFontStyle.FREE_SPINS_REMAINING, new Point(0, -100), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(200, 200));
    }
}
//# sourceMappingURL=GameFreeSpinsCounterProperties.js.map